<template>
  <div class="block-contact-card">
    <BlockInfoPharmacy
      v-if="location && !stores"
      :data="location"
      class="block-contact-card__info-pharmacy"
    />

    <div v-if="stores">
      <BlockInfoPharmacy
        v-for="(store, index) in stores"
        :key="index"
        :data="store"
        class="block-contact-card__info-pharmacy"
      />
    </div>
  </div>
</template>
<script setup>
const props = defineProps({
    data: {
        type: Object,
        default: () => {},
    },
});
/*
    Fetch Location
*/
const { find, findOne } = useStrapi4();
const location = ref(null);
const stores = ref(null);
const computedId = computed(() => props.data?.location);

const setLocation = async () => {
    try {
        const id = computedId.value;
        if (id) {
            /* If store is set with dropdown fetch the shop from strapi */
            const { data } = await findOne('stores', id, {
                fields: [
                    'name',
                    'street',
                    'number',
                    'phone',
                    'email',
                    'postcode',
                    'city',
                    'opening_times',
                ],
                populate: {
                    image: true,
                },
            });
            data.attributes.id = data.id;
            data.attributes.image = data.attributes?.image?.data?.attributes;
            location.value = data.attributes;
        } else {
            const context = useContextStore();
            const storeIds = context.getStoreId;
            let storesData = [];
            let jobId = null;

            const collection = context.getCollection;
            if (collection === 'api::store.store') {
                storeIds.push(context.getId);
            }

            if (collection === 'api::job.job') {
                jobId = context.getId;
            }

            if (storeIds?.length > 0) {
                const { data } = await find('stores', {
                    filters: {
                        id: {
                            $in: storeIds,
                        },
                    },
                    fields: [
                        'name',
                        'street',
                        'number',
                        'phone',
                        'email',
                        'postcode',
                        'city',
                        'opening_times',
                    ],
                    populate: {
                        image: true,
                        jobs: true,
                    },
                });
                storesData = data;
            }

            const strapiStores = storesData
                .filter((store) => {
                    if (jobId === null) {
                        return true;
                    }
                    const jobIds = store.attributes.jobs.data.map((job) => job.id);
                    return jobIds.includes(jobId);
                }).map((store) => {
                    const storeData = store;
                    storeData.attributes.id = store.id;
                    storeData.attributes.image = store.attributes?.image?.data?.attributes;

                    return storeData.attributes;
                });

            if (strapiStores.length >= 1) {
                stores.value = strapiStores.map((store) => ({
                    name: store.name,
                    street: store.street,
                    number: store.number,
                    phone: store.phone,
                    email: store.email,
                    postcode: store.postcode,
                    city: store.city,
                    opening_times: store.opening_times,
                    image: store.image,
                }));
            }

            if (strapiStores.length > 0) {
                location.value = {
                    name: strapiStores[0].name,
                    street: strapiStores[0].street,
                    number: strapiStores[0].number,
                    phone: strapiStores[0].phone,
                    email: strapiStores[0].email,
                    postcode: strapiStores[0].postcode,
                    city: strapiStores[0].city,
                    opening_times: strapiStores[0].opening_times,
                    image: strapiStores[0].image,
                };
            }
        }
    } catch (e) {
        useSentryError(e);
    }
};

const { execute } = useLazyAsyncData(`stores/${getUid}`, () => setLocation(), {});

/*
    For storyblok only: refetch location if select field value changes
*/
const route = useRoute();

if (route.query._storyblok) {
    watch(() => computedId.value, () => {
        execute();
    });
}
</script>

<style lang="scss" scoped>
.block-contact-card {
    @include component-spacing(30px, 60px);

    @include top-level-only {
        @include default-content-columns;
    }
}

.block-contact-card__info-pharmacy {
    // Reset Display Grid Property from Block Info Pharmacy
    display: block;
}
</style>
